'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _cookie = require('@alife/zoro-cookie/lib/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * AE 日志收集打点app
 * 无需初始化，js引用后自动初始化
 */
var ClickStat = function () {
    function ClickStat() {
        (0, _classCallCheck3.default)(this, ClickStat);
    }

    (0, _createClass3.default)(ClickStat, [{
        key: 'buttonClick',

        /* 按钮，Banner打点，请求url : http://stat.alibaba.com/ae/aliexpress_button_click.html
        * @param
        *       projectId: 打点项目id
        *       pageType: 打点场景页面 默认为search_list 根据情况覆盖
        *       buttonType: 按钮类型
        *       objectType: 打点数据类型
        *       objectValue: 打点数据
        *       stPageId: 页面id
        ×       clickBehavior: 点击行为ctrlleft,left,right,middle,other
        */
        value: function buttonClick(paramsObj) {
            var projectId = paramsObj.projectId || '';

            var pageType = paramsObj.pageType || '';

            var pageArea = paramsObj.pageArea || '';

            var buttonType = paramsObj.buttonType || '';

            var objectType = paramsObj.objectType || '';

            var objectValue = paramsObj.objectValue || '';

            var stPageId = paramsObj.stPageId || '';

            var clickBehavior = paramsObj.clickBehavior || '';
            var cookieId = _cookie2.default.get('ali_apache_id') || '';
            var memberId = _zoroCookie2.default.getMemberSeq() || '';

            var userId = '';
            var isMember = false;
            if (memberId !== '') {
                isMember = true;
                userId = memberId;
            } else {
                userId = cookieId;
            }

            var params = {
                ae_project_id: projectId,
                ae_page_type: pageType,
                ae_page_area: pageArea,
                ae_button_type: buttonType,
                ae_object_type: objectType,
                ae_object_value: objectValue,
                ae_ismember: isMember,
                ae_user_id: userId,
                st_page_id: stPageId,
                ae_click_behavior: clickBehavior
            };
            if (typeof dmtrack !== 'undefined') {
                window.dmtrack.clickstat(window.location.protocol + '//stat.alibaba.com/ae/aliexpress_button_click.html', params);
            }
        }

        /**
         * 曝光打点 请求url http://stat.alibaba.com/ctr/aliexpress_ctr.html
         * @param
         *  project_id: 项目ID
         *  exp_page: 曝光页面
         *  exp_page_area: 曝光区域
         *  exp_type: 曝光应用场景
         *  exp_condition: 曝光条件
         *  exp_product: 曝光产品值串
         *  exp_attribute: 曝光属性
         *  exp_result_cnt: 曝光总结果数
         *  Page_size: 曝光一页的结果数
         *  Page_no: 曝光页面号
         *  refer: 页面前一个url
         *  scm_id: 曝光产品串scm值
         *  pvid: 曝光产品串pvid值
         */

    }, {
        key: 'ctr',
        value: function ctr(paramsObj) {
            var projectId = paramsObj.projectId || '';

            var expPage = paramsObj.expPage || '';

            var expPageArea = paramsObj.expPageArea || '';

            var expType = paramsObj.expType || '';

            var expCondition = paramsObj.expCondition || '';

            var expProduct = paramsObj.expProduct || '';

            var expAttribute = paramsObj.expAttribute || '';

            var expResultCnt = paramsObj.expResultCnt || '';

            var pageSize = paramsObj.pageSize || '';

            var pageNo = paramsObj.pageNo || '';

            var refer = paramsObj.refer || '';

            var scmId = paramsObj.scmId || '';

            var pvid = paramsObj.pvid || '';

            var params = {
                project_id: projectId,
                exp_page: expPage,
                exp_page_area: expPageArea,
                exp_type: expType,
                exp_condition: expCondition,
                exp_product: expProduct,
                exp_attribute: expAttribute,
                exp_result_cnt: expResultCnt,
                Page_size: pageSize,
                Page_no: pageNo,
                refer: refer,
                scm_id: scmId,
                pvid: pvid
            };
            if (typeof dmtrack !== 'undefined') {
                window.dmtrack.clickstat(window.location.protocol + '//stat.alibaba.com/ctr/aliexpress_ctr.html', params);
            }
        }

        /**
         * 曝光打点 P4P list 请求url http://stat.alibaba.com/ctr/aliexpress_p4p_ctr.html
         *  session_id: P4P曝光ID
         *  product_id: P4P product id
        */

    }, {
        key: 'p4pCtr',
        value: function p4pCtr(obj) {
            var params = {
                session_id: obj.sessionId,
                product_id: obj.productId
            };

            if (typeof dmtrack !== 'undefined') {
                window.dmtrack.clickstat(window.location.protocol + '//stat.alibaba.com/ctr/aliexpress_p4p_ctr.html', params);
            }
        }
    }]);
    return ClickStat;
}();

exports.default = new ClickStat();